import StreamAccountModel from '../../models/stream/StreamAccountModel.js';

const StreamAccountCollection = Backbone.Collection.extend({
  name: 'streamAccounts',
  model: StreamAccountModel,
  defaults: {
    query: 'unknown',
  },
  initialize() {
  },

  sync(method, collection, options) {
    const $username = loginContext.getCurrentDetails().username;
    const key = `${$username}_streamAccounts`;
    const cache = new Cache();

    options.refreshCache = (options.hasOwnProperty('refreshCache')) ? options.refreshCache : false;

    if (method == 'read') {
      if (cache.read(key) == null || options.refreshCache) {
        return Sendible.Connect.getStreamAccounts(
          window.appConfig.applicationId,
          $username,
          $password,
          (data) => {
            options.success(data);
            cache.store(key, JSON.stringify(data));
          },
          (data) => {
            options.error(data);
          },
        );
      }

      options.success(JSON.parse(cache.read(key)));
    }
  },

  parse(data) {
    return data;
  },

  page: 1,

  processPages() {
    const pages = [];
    let row = [];
    const array = [];
    let pageNumber = null;
    const { pageLength } = this;
    const { rowLength } = this;
    const $pages = this.view.$el.find(this.pageListEl);

    // set page number
    if ($pages.length === 0) pageNumber = this.view.currentPage;
    if ($pages.length > 0) pageNumber = $(_.first($pages)).data('page-number');

    // Loop through collection splitting it by page length (pages)
    for (let pageIndex = 0; pageIndex < this.models.length; pageIndex += pageLength) {
      // add models in page rage to row
      pages.push(this.models.slice(pageIndex, pageIndex + pageLength));
    }

    // Loop each "page", splitting it into chunks (rows)
    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
      // Reset the row array
      row = [];

      for (let rowIndex = 0; rowIndex < pages[pageIndex].length; rowIndex += rowLength) {
        // add models to chunk
        row.push(pages[pageIndex].slice(rowIndex, rowIndex + rowLength));
      }

      // add page meta data
      row.push({ pageNumber: (pageNumber + pageIndex) });

      // add row to array
      array[pageIndex] = row;
    }

    // return
    return array;
  },

  resetCache() {
    const cache = new Cache();
    const key = `${loginContext.getCurrentDetails().username}_streamAccounts`;

    cache.removeLike(key);
  },

});

export default StreamAccountCollection;
